import React, { useEffect } from 'react'

import { useRoute } from '@react-navigation/native'
import { publishEvent } from '@zet/analytics'
import { BottomSheet, YStack } from '@zet/design-system'

import { creditCardCrossSellingData } from '../../../api/crossSelling/types'
import CrossSellingBottomSheetButton from './crossSellingBottomSheetButton'
import CrossSellingBottomSheetHeading from './crossSellingBottomSheetHeading'
import CrossSellingBottomSheetProductCard from './crossSellingBottomSheetProductCard'

interface CrossSellingBottomSheetProps {
  isBottomSheetVisible: boolean
  setIsBottomSheetVisible: (x: boolean) => void
  crossSellingData: creditCardCrossSellingData
  customerName: string
  customerId: number
  isEligibleCard?: boolean
  currentBrandName?: string
  crossSellingBrandName?: string
  handlePress?: () => void
  customerPhoneNumber: number
  tier: string
  extraPayoutPercentage: number
}

const CrossSellingBottomSheet = ({
  isBottomSheetVisible,
  setIsBottomSheetVisible,
  crossSellingData,
  customerName,
  customerId,
  currentBrandName,
  isEligibleCard,
  handlePress,
  customerPhoneNumber,
  crossSellingBrandName,
  tier,
  extraPayoutPercentage,
}: CrossSellingBottomSheetProps) => {
  const route = useRoute()
  const brandId = crossSellingData?.partner?.partnerId

  useEffect(() => {
    publishEvent('screen_view', {
      screen_name: isEligibleCard
        ? 'cross-nonapi-listing-bdp'
        : 'cross-nonapi-rec-bdp',
    })
  }, [])

  return (
    <BottomSheet
      visible={isBottomSheetVisible}
      disableBottomSheet={() => setIsBottomSheetVisible(false)}
      sheetName="cross-nonapi"
    >
      <YStack>
        <CrossSellingBottomSheetHeading
          customerName={customerName}
          brandName={crossSellingBrandName}
        />
        <CrossSellingBottomSheetProductCard
          route={route}
          creditCardCrossSellingData={crossSellingData}
          customerId={customerId}
          tier={tier}
          extraPayoutPercentage={extraPayoutPercentage}
        />
        <CrossSellingBottomSheetButton
          isEligibleCard={isEligibleCard}
          currentBrandName={currentBrandName}
          crossSellingBrandName={crossSellingBrandName}
          handlePress={handlePress}
          brandId={brandId}
          customerName={customerName}
          customerId={customerId}
          customerPhoneNumber={customerPhoneNumber}
        />
      </YStack>
    </BottomSheet>
  )
}

export default CrossSellingBottomSheet
